import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'
import {
  TABLE_CONTACTS,
  TABLE_CONTACT_ACCOUNTS,
  TABLE_CONTACT_DEALS,
  TABLE_CONTACT_PROSPECTS,
  FIELD_KEY_SEPARATOR,
  FIELD_KEY_PROG,
  FIELD_KEY_ACTION
} from '../globals.ts'
import { ContactsModelFields } from './contacts_model.ts'
import { ContactAccountsModelFields } from './contact_accounts_model.ts'
import { ContactDealsModelFields } from './contact_deals_model.ts'
import { ContactProspectsModelFields } from './contact_prospects_model.ts'

const ALIAS_CONTACTS = `${TABLE_CONTACTS}${FIELD_KEY_SEPARATOR}` as const
const ALIAS_CONTACT_ACCOUNTS = `${TABLE_CONTACT_ACCOUNTS}${FIELD_KEY_SEPARATOR}` as const
const ALIAS_CONTACT_DEALS = `${TABLE_CONTACT_DEALS}${FIELD_KEY_SEPARATOR}` as const
const ALIAS_CONTACT_PROSPECTS = `${TABLE_CONTACT_PROSPECTS}${FIELD_KEY_SEPARATOR}` as const

const FIELD_ID = `${ALIAS_CONTACTS}${ContactsModelFields.id}` as const
const FIELD_EMAIL = `${ALIAS_CONTACTS}${ContactsModelFields.email}` as const
const FIELD_LAST_NAME = `${ALIAS_CONTACTS}${ContactsModelFields.last_name}` as const
const FIELD_FIRST_NAME = `${ALIAS_CONTACTS}${ContactsModelFields.first_name}` as const
const FIELD_PREFERRED_NAME = `${ALIAS_CONTACTS}${ContactsModelFields.preferred_name}` as const
const FIELD_PHOTO_URL = `${ALIAS_CONTACTS}${ContactsModelFields.photo_url}` as const
const FIELD_CONTACT_ACCOUNTS_ID = `${ALIAS_CONTACT_ACCOUNTS}${ContactAccountsModelFields.id}` as const
const FIELD_CONTACT_DEALS_ID = `${ALIAS_CONTACT_DEALS}${ContactDealsModelFields.id}` as const
const FIELD_CONTACT_PROSPECTS_ID = `${ALIAS_CONTACT_PROSPECTS}${ContactProspectsModelFields.id}` as const

const PROG_DISPLAY_NAME = `${FIELD_KEY_PROG}display_name` as const
const PROG_CONTACTS_ACTION = `${FIELD_KEY_PROG}${TABLE_CONTACTS}${FIELD_KEY_ACTION}` as const
const PROG_ACTION = `${FIELD_KEY_PROG}${FIELD_KEY_ACTION}` as const

export const UserEntrySchema = z
  .object({
    [FIELD_ID]: z.string().nullish(),
    [FIELD_EMAIL]: z.string().nullish(),
    [PROG_DISPLAY_NAME]: z.string().nullish(), // TODO: What is this?
    [FIELD_LAST_NAME]: z.string().nullish(),
    [FIELD_FIRST_NAME]: z.string().nullish(),
    [FIELD_PREFERRED_NAME]: z.string().nullish(),
    [FIELD_PHOTO_URL]: z.string().nullish(),
    [FIELD_CONTACT_ACCOUNTS_ID]: z.string().nullish(),
    [FIELD_CONTACT_DEALS_ID]: z.string().nullish(),
    [FIELD_CONTACT_PROSPECTS_ID]: z.string().nullish(),
    [PROG_CONTACTS_ACTION]: z.string().nullish(),
    [PROG_ACTION]: z.string().nullish()
  })
  .strict()

export const UserEntryFields = makeFieldKeys(UserEntrySchema)

export type UserEntry = z.infer<typeof UserEntrySchema>

function validateUserEntry(data: unknown): UserEntry {
  try {
    return validateWithZodSchema(UserEntrySchema, data, 'user entry')
  } catch (error) {
    throw new Error(`User entry validation failed: ${error}`)
  }
}
